<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-card-title>
        <h4>Техническая поддержка &nbsp;<a :href="`/#/persons/${personid}`">{{title}}</a></h4>
      </v-card-title>
      <v-flex xs12 class="px-2">
        <v-card flat tile>
          <v-card-text>
            <v-textarea
            label="Ответ"
            v-model="post"
            outlined hide-details
            ></v-textarea>
          </v-card-text>
          <v-card-actions class="mt-0 pt-0">
            <v-spacer></v-spacer>
            <v-btn color="primary" outlined class="mb-1 mt-0 mr-2"
            :disabled="validForm === false"
            @click="send"
            >
              Отправить
              <v-icon right>send</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 v-if="chat" class="px-2">
        <v-sheet tile flat>
          <ChatMessage v-for="msg in chat.messages" :message="msg" :title="title" :personid="personid" class="my-0">
          </ChatMessage>
        </v-sheet>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ChatMessage from '@/components/ChatMessage.vue'

export default {
  name: 'Support',
  components: { ChatMessage },
  props: [ 'chatid' ],
  data: () => ({
    title: null,
    chat: { messages: [] },
    post: null,
    personid: null,
    users: []
  }),
  methods: {
    async fetch () {
      const { users } = await this.fetchUsers()
      this.users = users
      const { chat } = await this.fetchChat()
      chat.messages = chat.messages.map(x => {
        if (x.operatorid) x.operator = this.getOperator(x.operatorid)
        return x
      })
      if (chat) {
        this.chat = chat
        this.title = chat.title
        this.personid = chat.personid
        this.$store.dispatch('sioOn', {
          topic: 'chatmessage',
          cb: (x) => {
            if (x.chatid === chat.chatid) {
              if (x.operatorid) x.operator = this.getOperator(x.operatorid)
              this.chat.messages.unshift(x)
            }
          }
        })
      }
    },
    async fetchChat () {
      return this.$store.dispatch('sioRequest', {
        topic: 'fetch-chat',
        pl: {
          chatid: this.chatid
        }
      })
    },
    async fetchUsers () {
      return this.$store.dispatch('sioRequest', {
        topic: 'fetch-users',
        pl: {
          chatid: this.chatid
        }
      })
    },
    async send () {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'chat-post',
          pl: { content: this.post, chatid: this.chat.chatid }
        })
        this.$store.dispatch('snack', meta.msg)
        this.post = null
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    getOperator (id) {
      return this.users.find(x => x.operatorid === id)
    },
  },
  computed: {
    profile () {
      return this.$store.state.profile
    },
    validPost () {
      if (!this.post) return false
      return this.post.length > 1
    },
    validForm () {
      return this.validPost
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    }
  },
  async mounted () {
    if (this.profile) await this.fetch()
  }
}
</script>

<style lang="css">
</style>
